<div
	class="library-item-row"
	[class.active]="isActive()"
	data-cy="library-item-row"
	[class.tree-view-mode]="useTreeView"
	[attr.data-node-level]="nodeLevel"
	[style.--node-level]="nodeLevel">
	<span
		[attr.aria-label]="getAriaLabel(item)"
		[attr.data-tree-node-key]="null"
		(click)="loadItemDetails('expandItem', item)"
		[attr.tabindex]="useTreeView ? null : '0'"
		(keyup.enter)="!useTreeView && loadItemDetails('expandItem', item)"
		[attr.aria-expanded]="useTreeView ? null : isItemExpanded()"
		class="library-item-info"
		[class.withMargin]="multiSelect"
		data-cy="library-item-details"
		>
		@if (!multiSelect) {
			<i
				class="library-item-icon"
				[ngClass]="iconClass"
			></i>
		}
		@if (multiSelect && !useTreeView) {
			<mat-checkbox
				color="primary"
				(click)="$event.stopPropagation()"
				[checked]="item.checked"
				[(ngModel)]="item.checked"
				(change)="checkSelection()"
				[aria-label]="
					(item.checked
						? 'library-collections_multi-deselect-one'
						: 'library-collections_multi-select-one'
					) | translate : { item: item.name }">
			</mat-checkbox>
		} @else if (multiSelect && useTreeView) {
			<mat-checkbox
				color="primary"
				(click)="$event.stopPropagation()"
				[checked]="node.checked"
				(change)="onCheckboxChange($event.checked)"
				[aria-label]="
					(node.checked
						? 'library-collections_multi-deselect-one'
						: 'library-collections_multi-select-one'
					) | translate : { item: node.data.name }">
			</mat-checkbox>
		}

		<span class="collection-item-name" data-cy="collection-item-name">
			{{ item.name || "common_untitled" | translate }}
		</span>
		<span class="collection-item-modified-date">
			{{ formatDate(item.modified_at) }}
		</span>
	</span>
	@if (!multiSelect) {
		<button
			[matMenuTriggerFor]="menu"
			class="menu-btn collection-item-menu item-options-dropdown-menu btn-none"
			data-cy="library-item-dropdown-menu"
			[attr.aria-label]="'collection-item-menu' | translate"
			(click)="setActiveToggle($event)"
			>
			<i class="ficon-app-dots-vertical"></i>
		</button>
	}
	<mat-menu #menu="matMenu" class="collection-item-dropdown-menu">
		@if (displayMenuOptions | async) {
			<button
				mat-menu-item
				data-cy="common-preview"
				class="preview-option"
				(click)="loadItemDetails('previewItem', item)"
				>
				<span>{{ "common_preview" | translate }}</span>
			</button>
			@if (shouldShowEdit()) {
				<button
					mat-menu-item
					data-cy="edit-library-item-button"
					class="edit-option"
					(click)="loadItemDetails('edit', item)"
					>
					<span>{{ "common_edit" | translate }}</span>
				</button>
			}
			<button
				mat-menu-item
				data-cy="common_copy"
				class="copy-option"
				(click)="copyItem(item)"
				>
				<span>{{ "common_copy" | translate }}</span>
			</button>
			@if (canMove(item)) {
				<button
					mat-menu-item
					data-cy="common-move"
					class="move-option"
					(click)="moveItem(item)"
					>
					<span>{{ "common_move" | translate }}</span>
				</button>
			}
			@if (canShare()) {
				<button
					mat-menu-item
					class="share-option"
					(click)="loadItemDetails('shareItem', item)"
					>
					<span>{{ "common_share" | translate }}</span>
				</button>
			}
			@if (canRemove(item)) {
				<button
					mat-menu-item
					data-cy="common-remove"
					class="remove-option"
					(click)="removeItem(item)"
					>
					<span>{{ "common_remove" | translate }}</span>
				</button>
			}
			@if (shouldShowDownloadButton(item)) {
				<button
					mat-menu-item
					data-cy="download-library-item"
					class="download-option"
					(click)="downloadItem(item)"
					>
					<span>{{ "common_download" | translate }}</span>
				</button>
			}
			@if (canRestore(item)) {
				<button
					mat-menu-item
					class="restore-option"
					(click)="moveItem(item)"
					>
					<span>{{ "common_restore" | translate }}</span>
				</button>
			}
			@if (!UADetect.isMobile() && itemInUse) {
				<button
					mat-menu-item
					class="download-report-option"
					(click)="downloadReport(item)"
					>
					<span>{{ "library-collections_download-report" | translate }}</span>
				</button>
			}
		} @else {
			<div class="loading-items">
				<i class="ficon-spinner ficon-spin"></i>
			</div>
		}
	</mat-menu>
	@if (useTreeView && (isLoadingDetailsForItem | async)) {
		<div class="loading-indicator-row">
			<mat-progress-bar [attr.aria-label]="'common_loading'| translate" mode="indeterminate"></mat-progress-bar>
		</div>
	}
</div>

@if (isItemExpanded() && (isLoadingDetailsForItem | async) === false) {
	<div class="library-item-expanded">
		<div class="library-item-details" tabindex="0">
			<div class="library-item-details-row title-row">
				<span
					class="library-item-details-title"
					translate="library-collections_details-name"
				></span>
				<span>{{ item.name || "common_untitled" | translate }}</span>
			</div>
			<div class="library-item-details-row mobile-only">
				<span
					class="library-item-details-title"
					translate="library-collections_details-last-modified"
				></span>
				<span>{{ formatDate(item.modified_at) }}</span>
			</div>
			@if (item.location) {
				<div class="library-item-details-row location-row">
					<span
						class="library-item-details-title"
						translate="library-collections_details-location"
					></span>
					<span>{{ item.location }}</span>
				</div>
			}
			<div class="library-item-details-row">
				<span
					class="library-item-details-title"
					translate="library-collections_details-creator"
				></span>
				<span>{{ item.creator_name }}</span>
			</div>
			<div class="library-item-details-row">
				<span
					class="library-item-details-title"
					translate="library-collections_details-creation-date"
				></span>
				<span>{{ formatDate(item.item.created_at) }}</span>
			</div>
			<div class="library-item-details-row description-row">
				<span
					class="library-item-details-title"
					translate="library-collections_details-description"
				></span>
				<span class="library-item-description">{{ item.description }}</span>
			</div>
		</div>
		@if (item.collection_item_type === 'media' && media) {
			<ngx-media-thumbnail
				class="media-thumbnail"
				[media]="media"
			></ngx-media-thumbnail>
		}
		<div class="library-item-buttons">
			@if (shouldShowEdit()) {
				<button
					type="button"
					class="tertiary-btn edit-btn"
					data-cy="expanded-item-edit-btn"
					(click)="loadItemDetails('edit', item)"
					>
					<span translate="common_edit"></span>
				</button>
			}
			@if (showPreviewButton(item)) {
				<button
					type="button"
					class="secondary-btn preview-btn"
					data-cy="library-item-preview-button"
					(click)="loadItemDetails('previewItem', item)"
					>
					<span translate="library-collections_details-preview"></span>
				</button>
			}
			@if (mode === modes.SELECT) {
				<button
					data-cy="library-item-select"
					type="submit"
					class="primary-btn submit-btn"
					(click)="selectItem.emit({item: item})"
					>
					<span translate="library-collections_details-select"></span>
				</button>
			}
		</div>
	</div>
}
